import { VimeoFrame, SmallVimeoFrame, ModalWrapper, Clue, TimeSwitch, Link, DisplayOnce } from "../../utils/fw"
import { TimedPopup } from "../components/TimedPopup"

export default {
	backgroundFunction: () => [
		["2021-11-01T08:00+00:00", "https://assets.swoogo.com/uploads/full/1459482-61854df20e4a1.jpg"],
		["2021-11-17T22:00+00:00", "https://assets.swoogo.com/uploads/full/1472259-6192b38dc814d.jpg"],
	].sort((a, b) => a[0] < b[0] ? 1 : -1).find(i => new Date(i[0]) < new Date())[1]
	,
	default: true,
	extras: (
		<>
			<video autoPlay loop
				id="sponsor-banner"
				src="https://assets.swoogo.com/uploads/1459435-618548ed9fac0.mp4"
			/>
			<iframe
				className="social-media-wall"
				style="height: 18.2%; left: 11.6%; top: 5.6%; width: 16%; position: absolute; cursor: pointer; border: none;"
				src="https://my.walls.io/InspireDays?show_header=0%22"
				allowfullscreen
			/>
			<img
				className="social-media-wall"
				style="height: 18.2%; left: 11.6%; top: 35.2%; width: 15.91%; position: absolute; cursor: pointer; border: none;"
				src="https://assets.swoogo.com/uploads/full/1481517-6197c1d56ec56.png"
			/>
			<DisplayOnce>
				<ModalWrapper dismissStyle={{ right: "2vw", top: "2vw" }}>
					<div style={{ color: "white", maxWidth: "50vw", padding: "1vw" }}>
						<h1>Thank you for attending Inspire Days 2021, the event is now closed.</h1>
						<p>You can access all sessions on demand via the top navigation bar, as well as visit our Exhibition Hall and Resource Hub.</p>
						<p>The platform will be available until December 3rd, after which you will be able to access all Inspire Days content on Quadient.com.</p>
					</div>
				</ModalWrapper>
			</DisplayOnce>
		</>
	),
	links: [
		{
			label: "Photobooth",
			height: "35.7%",
			left: "0.3%",
			top: "54.3%",
			width: "15%",
			// onClick: () => { document.getElementById("quadient2021-photobooth").click() }
			modal: <ModalWrapper dismissStyle={{ right: "2vw", top: "2vw" }}>
				<div style={{ color: "white", maxWidth: "50vw", padding: "1vw" }}>
					<h1>The Photobooth is now closed.</h1>

				</div>
			</ModalWrapper>
		},
		{
			height: "18.3%",
			label: "Information/Help Desk",
			// onClick: () => openSmartSupp(),
			left: "55.4%",
			top: "75.4%",
			width: "17.3%",
			modal: <ModalWrapper dismissStyle={{ right: "2vw", top: "2vw" }}>
				<div style={{ color: "white", maxWidth: "50vw", padding: "1vw" }}>
					<h1>Thank you for attending Inspire Days 2021, the event is now closed.</h1>
					<p>You can access all sessions on demand via the top navigation bar, as well as visit our Exhibition Hall and Resource Hub.</p>
					<p>The platform will be available until December 3rd, after which you will be able to access all Inspire Days content on Quadient.com.</p>
				</div>
			</ModalWrapper>
		},
		{
			label: "Quadient Logo",
			height: "10.9%",
			left: "54%",
			top: "38.3%",
			width: "21.1%",
			modal: <ModalWrapper wrapperStyle={{ backgroundColor: "#7536f0" }}><Clue
				letter="&quot;V&quot;!"
			></Clue></ModalWrapper>
		},
		{
			label: "Main Stage",
			height: "23.9%",
			left: "56%",
			top: "51.3%",
			width: "15.1%",
			CometChatID: "main-stage",
			href: "/main-stage"
			// modal: <ModalWrapper dismissStyle={{ right: "2vw", top: "2vw" }}>
			// 	<div style={{ color: "white", maxWidth: "50vw", padding: "1vw" }}>
			// 		<h1>Thank you for attending Inspire Days 2021, the event is now closed.</h1>
			// 		<p>You can access all sessions on demand via the top navigation bar, as well as visit our Exhibition Hall and Resource Hub.</p>
			// 		<p>The platform will be available until December 3rd, after which you will be able to access all Inspire Days content on Quadient.com.</p>
			// 	</div>
			// </ModalWrapper>
		},
		{
			label: "Exhibition Hall",
			href: "/exhibition-hall",
			height: "24.8%",
			left: "28%",
			top: "51.8%",
			width: "13.5%",
		},
		{
			label: "Product Q&A",
			height: "33%",
			left: "83.9%",
			top: "49.9%",
			width: "11.6%",
			href: "/networking"
			// modal: <ModalWrapper dismissStyle={{ right: "2vw", top: "2vw" }}>
			// 	<div style={{ color: "white", maxWidth: "50vw", padding: "1vw" }}>
			// 		<h1>Thank you for attending Inspire Days 2021, the event is now closed.</h1>
			// 		<p>You can access all sessions on demand via the top navigation bar, as well as visit our Exhibition Hall and Resource Hub.</p>
			// 		<p>The platform will be available until December 3rd, after which you will be able to access all Inspire Days content on Quadient.com.</p>
			// 	</div>
			// </ModalWrapper>
		},
		{
			label: "Breakouts",
			height: "22.1%",
			left: "54.2%",
			top: "7.6%",
			width: "6.9%",
			href: "/breakouts"
			// modal: <ModalWrapper dismissStyle={{ right: "2vw", top: "2vw" }}>
			// 	<div style={{ color: "white", maxWidth: "50vw", padding: "1vw" }}>
			// 		<h1>Thank you for attending Inspire Days 2021, the event is now closed.</h1>
			// 		<p>You can access all sessions on demand via the top navigation bar, as well as visit our Exhibition Hall and Resource Hub.</p>
			// 		<p>The platform will be available until December 3rd, after which you will be able to access all Inspire Days content on Quadient.com.</p>
			// 	</div>
			// </ModalWrapper>
		},
		{
			label: "Resource Hub",
			href: "/resource-hub",
			height: "22.3%",
			left: "61.3%",
			top: "7%",
			width: "7.7%",
		},
	],
	name: "lobby",
}
